"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var AssetType;
(function (AssetType) {
    AssetType["Season"] = "season";
    AssetType["Episode"] = "episode";
})(AssetType = exports.AssetType || (exports.AssetType = {}));
//# sourceMappingURL=AssetType.js.map